// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@hotwired/turbo-rails")
require("channels")
require("trix")
require("@rails/actiontext")

// Carousel
import { Application } from "stimulus"
import Carousel from "stimulus-carousel"

const application = Application.start()
application.register("carousel", Carousel)

import 'swiper/swiper-bundle.min.css'

// Analytics
import ahoy from "ahoy.js"
ahoy.trackAll()
// ahoy.trackView()

// TailwindCSS
import "stylesheets/jute_page.scss";

// Stimulus controllers
import "controllers"

const components = require.context("src", true)
components.keys().forEach(components)
